import React from 'react'
import { styled } from 'styled-components'
import { BACKGROUND_VIDEO_URL } from '../../assets/constants'

const Frame = styled.div`
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	overflow: hidden;
	height: 100%;
	width: 100%;
	user-select: none;
	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		color: white;
		margin: auto 0;
		text-shadow: 0 0 1px #fff, 0 0 4px #fff;
		font-weight: 750;
		letter-spacing: 2px;
	}
	h1 {
		font-size: 2.1em;
	}
	h2 {
		font-size: 2em;
	}
	h3 {
		font-size: 1.9em;
	}
	h4 {
		font-size: 1.7em;
	}
	h5 {
		font-size: 1.5em;
	}
	h6 {
		font-size: 1.4em;
	}

	video {
		position: fixed;
		left: 0;
		top: 0;
	}
`

const PaddedFrame = styled.div`
	position: relative;
	padding: 2%;
	height: 100%;
	max-height: 100%;
	min-height: 100%;
	width: 100%;
	max-width: 100%;
	min-width: 100%;
	overflow: hidden;
`

const StyledBackgroundVideo = styled.video`
	position: fixed;
	width: 100%;
	height: 100%;
	object-fit: fill;
	z-index: -1;
`

export default function FrameComponent({
	children,
	...passAlongProps
}: {
	children: React$Node,
}): React$Node {
	return (
		<Frame>
			<BackgroundVideo />
			<PaddedFrame {...passAlongProps}>{children}</PaddedFrame>
		</Frame>
	)
}

/**
 * A basic background video that plays on a loop. has position fixed and it is spread across the whole screen. Use this when a nice purply background is needed
 */
export function BackgroundVideo({
	className,
	src,
}: {
	className?: string,
	src?: string,
}): React$Node {
	return (
		<StyledBackgroundVideo autoPlay muted={true} loop className={className}>
			<source src={src || BACKGROUND_VIDEO_URL} />
		</StyledBackgroundVideo>
	)
}
